import React from 'react';
import { Button, Spinner } from 'react-bootstrap';
import { FaFileExcel, FaSearch, FaTrash } from 'react-icons/fa';
import { toast } from 'react-toastify';
import moment from 'moment';
import { exportarEmExcel } from '~/Utils/Helpers';

// W-0600 — export client-side (backend não expõe endpoint de export, só /gerar JSON).
const BotoesAcao = ({
  onGerar,
  onLimpar,
  loading,
  temResultado,
  linhas,
  detalhe,
  dataInicio,
  dataFim,
}) => {
  const handleExportar = () => {
    if (!temResultado) {
      toast.warning('Gere o relatório antes de exportar.');
      return;
    }

    const cabecalho = detalhe
      ? ['Nome', 'Data', 'Título', 'Tipo']
      : ['Nome', 'Qtde'];

    const corpo = (linhas || []).map((item) =>
      detalhe
        ? [
            item.nome,
            item.data ? moment(item.data).format('DD/MM/YYYY') : '',
            item.titulo,
            item.tipo,
          ]
        : [item.nome, item.qtde]
    );

    const ini = dataInicio ? moment(dataInicio).format('YYYY-MM-DD') : 'inicio';
    const fim = dataFim ? moment(dataFim).format('YYYY-MM-DD') : 'fim';
    exportarEmExcel([cabecalho].concat(corpo), `digitalizacoes_${ini}_${fim}.csv`);
  };

  return (
    <div className="d-flex flex-wrap gap-2 mb-3">
      <Button variant="primary" onClick={onGerar} disabled={loading}>
        {loading ? (
          <>
            <Spinner animation="border" size="sm" className="mr-1" />
            Gerando...
          </>
        ) : (
          <>
            <FaSearch className="mr-1" /> Gerar
          </>
        )}
      </Button>

      <Button
        variant="success"
        onClick={handleExportar}
        disabled={loading || !temResultado}
      >
        <FaFileExcel className="mr-1" /> Exportar Excel
      </Button>

      <Button variant="outline-secondary" onClick={onLimpar} disabled={loading}>
        <FaTrash className="mr-1" /> Limpar
      </Button>
    </div>
  );
};

export default BotoesAcao;
